'use client';
import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';

/**
 * Fires an ODP `pageview` on client-side route changes. The initial load is
 * already sent by the inline snippet in ZaiusScript, so the first pathname
 * this sees is recorded and not sent.
 */
export default function ZaiusPageView() {
  const pathname = usePathname();
  const lastPathRef = useRef(null);

  useEffect(() => {
    if (lastPathRef.current === pathname) return;

    const isFirstRun = lastPathRef.current === null;
    lastPathRef.current = pathname;
    if (isFirstRun) return;

    // `page` is pinned because the tracker reads the URL when it flushes its
    // queue, which can be after the next navigation.
    window.zaius?.event('pageview', { page: pathname });
  }, [pathname]);

  return null;
}
